<template>
  <div class="w-100">
    <!-- Boton Exportar excel-->
    <div style="position: relative" v-if="exportarExcel">
      <div class="d-flex" style="position: relative">
        <export-button
          :headers="headers"
          :data="data"
          :nombreArchivo="idtabla"
          style="margin: auto; margin-bottom: -45px; margin-right: 250px"
          :exportExcelCustom="exportExcelCustom"
          :isCustomExport="isCustomExport"
          :style="[
            btnSpecificZIndex === 1 
            ? ( zIndexModal || zIndexTablaModal
              ? { 'z-index': '0' }
              : { 'z-index': '1' } )
            : { 'z-index': btnSpecificZIndex } 
          ]"
        />

      </div>
    </div>

    <div v-if="!this.buscar" style="height: 40px;">

    </div>
    <!-- Contenido de la tabla -->
    <table
      class="table table-bordered stripe display compact hover"
      :id="nombreTabla"
    >
      <!-- Headers -->
      <thead>
        <tr>
          <!-- Si se encuentra la opción (Props) Check Se mostrará esta sección en la tabla -->
          <th v-if="check || si_checkbox || glosses_checkbox" style="width: 36px"></th>

          <!-- Numerador correlativo -->
          <th
            v-if="numerador"
            style="width: 30px !important; font-size: 12.5px"
          >
            #
          </th>

          <!-- Tabla con headers normales -->
          <template v-if="!customHeaders">
            <th
              v-for="(item, index_header) in headers"
              :key="index_header.title"
              style="font-size: 13px !important;"
              :style="{ width: item?.width }"
            >
              {{ item }}
            </th>
          </template>

          <!-- Tabla con headers personalizados -->
          <template v-else>
            <th
              v-for="(item, index_header) in headers"
              :key="index_header"
              style="font-size: 13px !important"
              :style="{ width: item.width }"
              
            >
              {{ item.title }}
            </th>
          </template>
        </tr>
      </thead>

      <!-- Body -->
      <tbody>
        <!-- Recorre el total de objectos dentro del array -->
        <tr v-for="(item, index) in dataAux" :key="index">
          <!-- 

           -->
          <!-- Si se encuentra la opción (Props) Check Se mostrará esta sección en la tabla, la cual habilita las casillas de selección checkbox -->
          <th
            v-if="check"
            type="checkbox"
            style="text-align: center"
          >
            <input
              style="text-align: center"
              class="checkccc"
              type="checkbox"
              @click="cambiarEstadoCheck($event, index)"
            />
          </th>

          <th v-if="si_checkbox"
            type="checkbox"
            style="text-align: center">
            <input
              style="text-align: center"
              class="checkccc"
              type="checkbox"
              :id="'checkbox-'+ index"
              @click="checkRow($event, index, item)"
            />
          </th>

          <th v-if="glosses_checkbox"
              type="checkbox"
              style="text-align: center">
            <input
              style="text-align: center"
              class="checkccc"
              type="checkbox"
              :id="'gloss-checkbox-'+ index"
              @click="checkRow($event, index, item)"
            />
          </th>
          <!-- 

           -->
          <!-- Si se encuentra la opción (Props) numerador se mostrará esta sección en la tabla, la cual habilita la numeración de numeros correlativos iniciando desde el n° 1 -->
          <td
            style="text-align: center; font-size: 12.5px"
            v-if="numerador"
            v-text="index + 1"
          ></td>

          <!-- 
            
            SI ESTÁ HABILITADO EL MODO FORMULARIO, SE MUESTRA ESTA SECCIÓN
            
          -->

          <template v-if="formulario">
            <td
              v-for="(item_data, index_data) in item.data"
              :key="index_data"
              style="font-size: 12.5px !important"
            >
              <!-- Muestra en la tabla los valores dentro del input / checkbox o select correspondiente -->
              <template v-for="(type, index_type) in item.type">
                <template v-if="type.key == index_data">
                  <!-- Textbox -->
                  <input
                    v-if="type.type == 'textbox'"
                    class="textbox_normal"
                    :key="index_type"
                    placeholder="Cantidad"
                    v-model="item.data[index_data]"
                  />

                  <input
                    v-if="type.type === 'carrier_booking_number'"
                    class="textbox_normal"
                    :key="index_type"
                    placeholder="Carrier Booking Number"
                    v-model="item.data[index_data]"
                  />

                  <!-- Checkbox -->
                  <input
                    :key="index_type"
                    :id="index_type"
                    v-if="type.type == 'checkbox'"
                    type="checkbox"
                    style="margin: 15px 0 0 25px; height: 15px; width: 15px"
                    @click="
                      type.function
                        ? funcionAuxiliar(
                            type.nameCategory,
                            $event,
                            index,
                            index_data
                          )
                        : ''
                    "
                  />

                  <input
                    :key="index_type"
                    :id="index_type"
                    v-if="type.type == 'checkboxset'"
                    type="checkbox"
                    v-model="item.data[index_data]"
                    style="margin: 15px 0 0 25px; height: 15px; width: 15px"
                    @click="
                      type.function
                        ? funcionAuxiliar(
                            type.nameCategory,
                            $event,
                            index,
                            index_data
                          )
                        : ''
                    "
                  />

                  <ui-select
                    v-if="type.type == 'select'"
                    class="textbox_normal"
                    :key="index_type"
                    has-search
                    placeholder="Seleccionar"
                    searchPlaceholder="Buscar"
                    v-model="item.seleccionados_aux.deposito"
                    :options="item_data"
                    :keys="{ value: 'id', label: 'name' }"
                    @change="
                      type.function
                        ? funcionAuxiliar(
                            type.nameCategory,
                            $event,
                            index,
                            index_data
                          )
                        : ''
                    "
                  />
                  <template v-if="type.type == 'select2'">
                    <ui-select
                      class="textbox_normal"
                      :key="index_type"
                      has-search
                      placeholder="Seleccionar"
                      searchPlaceholder="Buscar"
                      v-model="item.data[index_data]"
                      :options="item.selects[index_data]"
                      :keys="{ value: 'id', label: 'name' }"
                    />
                  </template>

                  <!-- Texto plano -->
                  <template v-if="type.type == 'text'">
                    {{ item.data[index_data] }}
                  </template>

                  <date-picker
                    v-if="type.type == 'date'"
                    :placeholder="
                      item.data[index_data].placeholder === undefined
                        ? 'Fecha'
                        : item.data[index_data].placeholder
                    "
                    type="date"
                    class="mb-3 mr-3 input_fecha"
                    value-type="format"
                    :key="index_type"
                    v-model="item.data[index_data]"
                  />
                </template>
              </template>
            </td>
          </template>

          <!-- SI NO ESTÁ HABILITADO EL MODO FORMULARIO, SE MUESTRA ESTA SECCIÓN -->
          <template v-else>
            <td
              v-for="(item_data, index_data) in item.data"
              :key="index_data"
              v-text="index_data >= 0 && item.data[index_data]"
              style="font-size: 12.5px !important"
            ></td>
          </template>

          <!-- Acciones -->
          <td v-if="acciones.length > 0">
            <a
              v-for="(item_acciones, index_2) in acciones[index]"
              :key="index_2"
              class="btn btn-sm icono"
              @click="filaSeleccionada(item_acciones.id, item_acciones.title)"
            >
              <i
                :class="item_acciones.icon"
                :title="item_acciones.title"
                style="text-align: center"
                :style="[
                  {
                    'font-size': item_acciones.size
                      ? item_acciones.size + 'px'
                      : '11.7px',
                  },
                ]"
              ></i>
              <!-- style="font-size: 11.7px; text-align: center" -->
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

// Importación de Jquery
import $ from "jquery";

// Comentado hasta nuevo aviso
// import Button from "./Button";

import DatePicker from "vue2-datepicker";

import ExportButton from "../common/ExportButton";

export default {
  components: {
    DatePicker,
    ExportButton,
    // Button
  },
  // components: { UiTextbox },
  props: {
    si_checkbox: { type: Boolean, default: false },
    glosses_checkbox: { type: Boolean, default: false },
    check: Boolean, // Permite agregar un checkbox como primer elemento de la tabla, esta opción esta deshabilitada por defecto
    customHeaders: Boolean, // Permite asignar el ancho de cada cabecera mediante un array de configuración {title: '', width: ''}
    headers: Array, // Titulos para cabecera de la tabla
    data: Array, // Contenido o información que mostrara la tabla
    acciones: Array, // Array de configuraciones para botones de la columna "Acciones"
    paginacion: Boolean, // Si la tabla tedra activa la opción de paginación, esta opción esta deshabilitada por defecto
    max: { type: Number, default: 10 }, // Numero de filas por cada pagina
    buscar: Boolean, // Filtrar filas, esta opción esta deshabilitada por defecto
    isCustomExport: Boolean,
    idtabla: {
      type: String,
      default: "id_generico",
    },
    // Prueba para poner input text y select
    seleccionar: { type: Function, default: () => ({}) },
    filaChekeada: { type: Function, default: () => ({}) },
    funcionAuxiliar: { type: Function, default: () => ({}) },
    exportExcelCustom: { type: Function, default: () => ({}) },
    numerador: { type: Boolean, default: false }, // Permite agregar numeración correlativca como indicador, esta opción esta deshabilitada por defecto
    formulario: { type: Boolean, default: false }, // Permite agregar contenido tipo select, textbox y checkbox a la tabla , esta opción esta deshabilitada por defecto
    exportarExcel: Boolean,
    btnSpecificZIndex: { type: Number, default: 1 }, // Permite agregar contenido tipo select, textbox y checkbox a la tabla , esta opción esta deshabilitada por defecto

  },

  data() {
    return {
      loading: true,
      lang: {
        lengthMenu: "Display _MENU_ records per page",
        zeroRecords: "No se encontraron registros coincidentes",
        info: "Mostrando página _PAGE_ de _PAGES_",
        infoEmpty: "No hay registros disponibles",
        infoFiltered: "(filtrado de _MAX_ registros totales)",
        search: "Buscar",
        paginate: {
          first: "Primero",
          last: "Ultimo",
          next: "Siguiente",
          previous: "Anterior",
        },
        buttons: {
          colvis: "Seleccionar columnas",
        },
      },
      nombreTabla: "id_tabla_" + this.idtabla,
      dataAux: this.data,
      accionesAux: this.acciones,
      flagFormulario: false,
      options: [],
      selected: [],
      selectAll: false,
    };
  },
  computed: {
    ...mapState(["zIndexModal", "zIndexTablaModal"]),
  },
  methods: {
    
    cambiarEstadoCheck(event, id) {
      let estado = event.target.checked;
      let accion = "fila_chekeada";
      this.filaChekeada({ id, estado, accion });
    },

    checkRow(event, index, item) {

      const status = event.target.checked;

      this.filaChekeada({status, index,  item});

    },

    select() {
      this.selected = [];
      if (!this.selectAll) {
        for (let i in this.options) {
          this.selected.push(this.options[i]);
        }
      }
    },
    updateCheckall: function () {
      if (this.options.length == this.selected.length) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },

    // Acciones de Vuex
    ...mapActions(["ActionSetLoading"]),

    filaSeleccionada(id, accion) {
      this.seleccionar({ id, accion });
    },

    resetChecks(){
      const checks = document.querySelectorAll('.checkccc');
      checks.forEach( element => element.checked = false );
    },

    configuracionDatatable() {
      let me = this;

      $("#" + this.nombreTabla)
        .DataTable()
        .destroy();

      $("#" + me.nombreTabla)
        .DataTable({
          paging: this.paginacion,
          pageLength: this.max,
          searching: this.buscar,
          lengthChange: false,
          ordering: true,
          info: true,
          autoWidth: false,
          responsive: true,
          checkd: false,
          language: me.lang,
        })
        .buttons()
        .container()
        .appendTo("#" + me.nombreTabla + "_wrapper .col-md-6:eq(0)");

      $(".exportar-tabla").click(() => {
        $("#" + me.nombreTabla)
          .DataTable()
          .buttons(2 - 1)
          .trigger();
      });
    },
  },

  mounted() {
    let me = this;
    me.configuracionDatatable();
  },

  watch: {

    data: function (_new) {
      let me = this;

      // Si watch detecta un cambio en la variable dataDatatableFilialesFiltrada la cual es un state de vuex, esta asignada el nuevo
      // valor a la variable data
      if (_new) {
        // Se debe destruir la tabla para cargar nuevos datos
        $("#" + this.nombreTabla)
          .DataTable()
          .destroy();

        setTimeout(() => {
          me.dataAux = _new;
        }, 300);

        setTimeout(() => {
          me.configuracionDatatable();
          me.ActionSetLoading(false);
        }, 700);

        this.resetChecks();
      }
    },

    acciones: function (_new) {
      if (_new) {
        this.accionesAux = _new;
      }
    },

  },

};

</script>

<style>

  .hide-button-excel {
    display: none;
  }

  .buttons-colvis {
    background-color: #dc3545;
    color: #ffff;
    padding: 6px;
    border: none;
    border-radius: 3px;
    font-size: 15px;
  }

  .buttons-colvis:hover {
    background-color: #bd2130;
    border: none;
  }

  div.dataTables_wrapper div.dataTables_info {
    font-size: 13px !important;
  }

  .icono {
    opacity: 0.7;
  }

  .icono:hover {
    opacity: 1;
  }

  .btn-group-sm > .btn,
  .btn-sm {
    padding: 0.25rem 0.45rem !important;
  }

  /* Table compact */

  table.dataTable.compact thead th,
  table.dataTable.compact thead td {
    padding: 3px 5px;
  }
  table.dataTable.compact tfoot th,
  table.dataTable.compact tfoot td {
    padding: 3px;
  }
  table.dataTable.compact tbody th,
  table.dataTable.compact tbody td {
    padding: 3px;
  }

  /* Table Hover */

  table.dataTable.hover > tbody > tr:hover > * {
    box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, 0.087) !important;
  }

  /* Stripe (Pintado de tabla estilo cebra) */

  table.dataTable.stripe > tbody > tr.odd > *,
  table.dataTable.display > tbody > tr.odd > * {
    box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, 0.048);
  }

  /*  */

  table.dataTable thead > tr > th.sorting,
  table.dataTable thead > tr > th.sorting_asc,
  table.dataTable thead > tr > th.sorting_desc,
  table.dataTable thead > tr > th.sorting_asc_disabled,
  table.dataTable thead > tr > th.sorting_desc_disabled,
  table.dataTable thead > tr > td.sorting,
  table.dataTable thead > tr > td.sorting_asc,
  table.dataTable thead > tr > td.sorting_desc,
  table.dataTable thead > tr > td.sorting_asc_disabled,
  table.dataTable thead > tr > td.sorting_desc_disabled {
    cursor: pointer;
    position: relative;
    padding: 10px 0 !important;
    text-align: center;
  }

  .textbox_normal {
    border: 1px solid grey;
    padding-left: 3px;
    height: 32px;
    border-radius: 5px;
    border: 1px solid #6c757d;
    width: 100%;
  }

</style>
